import script from "./ScreenRightCenter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScreenRightCenter.vue?vue&type=script&setup=true&lang=ts"

import "./ScreenRightCenter.vue?vue&type=style&index=0&id=70d86d55&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70d86d55"]])

export default __exports__